import gql from "graphql-tag";
import graphqlClient, { fragments } from "@/http/graphql/cbs";

export const GET_DEVICES_STATUS = `
    device_statuses {
		...DeviceStatus
	}
`;

export const GET_DEVICES = `
	devices (limit: $limit, page: $page, name: $name, search: $search, all: true, category_id: $category_id, sensor_has_data: $sensor_has_data, orderBy: $orderBy) {
		data {
			...Device
		}
		total
		per_page
	}
`;

export const GET_DEVICES_DASHBOARD = `
	devices (limit: $limit, page: $page, sensor_has_data: $sensor_has_data) {
		data {
			...DeviceDashboard
		}
		total
	}
`;

const GET_DEVICE = `
	device (id: $id) {
		...DeviceDetail
	}
`;

const ADD_DEVICE = `
	create_device (
		category_id: $category_id,
		inventory_id: $inventory_id,
		manage_employees: $manage_employees,
		name: $name,
		code: $code,
		serial: $serial,
		price: $price,
		status: $status,
		used_at: $used_at,
		images: $images,
		mfg: $mfg,
		wd: $wd,
		checked_times: $checked_times,
		repaired_total_cost: $repaired_total_cost,
		warning_threshold: $warning_threshold,
		alert_threshold: $alert_threshold,
		description: $description,
		maintain_hrs: $maintain_hrs,
		tag_ids: $tag_ids,
		inspection_deadline: $inspection_deadline
	) {
		...Device
	}
`;

const UPDATE_DEVICE = `
	update_device (
		id: $id,
		category_id: $category_id,
		inventory_id: $inventory_id,
		manage_employees: $manage_employees,
		name: $name,
		code: $code,
		serial: $serial,
		price: $price,
		status: $status,
		used_at: $used_at,
		images: $images,
		mfg: $mfg,
		wd: $wd,
		checked_times: $checked_times,
		repaired_total_cost: $repaired_total_cost,
		warning_threshold: $warning_threshold,
		alert_threshold: $alert_threshold,
		is_reset_counter: $is_reset_counter,
		description: $description,
		maintain_hrs: $maintain_hrs,
		tag_ids: $tag_ids,
		inspection_deadline: $inspection_deadline

	) {
		...Device
	}
`;

const DELETE_DEVICE = `
	delete_device (id: $id) {
		...Device
	}
`;

const CLONE_KPIS_TO_DEVICE = `
	clone_kpis_to_device (id: $id) {
		...Device
	}
`;

const EXPORT_REPORT_DEVICE = `
	export_report_device(device_id: $device_id, type: $type, from_start_date: $from_start_date, to_start_date: $to_start_date)
	`;

export default {
	init() {},

	fetchDevices(payload) {
		const queryOptions = {
			query: gql`query DevicesManagement ($limit: Int!, $page: Int!, $name: String, $search: String, $sensor_has_data: Boolean, $category_id: Int, $orderBy: OrderByObject) {
					${GET_DEVICES}
					${GET_DEVICES_STATUS}
				}
				${fragments.DeviceTask}
				${fragments.Device}
				${fragments.DeviceStatus}
				${fragments.DeviceKpis}
			`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1,
				name: payload.name || "",
				search: payload.search || "",
				category_id: payload.category_id,
				sensor_has_data: payload.sensor_has_data || null,
				orderBy: payload.orderBy || { column: "id", direction: "desc" }
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				devices: response.data.devices.data,
				devicesStatus: response.data.device_statuses || [],
				totalDevices: response.data.devices.total
			};
		});
	},

	getDevice(id) {
		const queryOptions = {
			query: gql`query DevicesManagementDetail ($id: Int) {
					${GET_DEVICE}
				}
				${fragments.DeviceDetail}
				${fragments.DeviceTask}
				${fragments.DeviceKpis}
			`,
			variables: {
				id: id
			}
		};

		return graphqlClient.query(queryOptions).then(response => response.data.device);
	},

	addDevice(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DevicesManagementCreate (
					$category_id: Int!,
					$inventory_id: Int,
					$manage_employees: [Int],
					$used_at: DateTime,
					$name: String!,
					$code: String,
					$serial: String,
					$price: Float,
					$status: Int,
					$images: [Int],
					$mfg: String,
					$wd: String,
					$checked_times: Float,
					$repaired_total_cost: Float,
					$warning_threshold: Float,
					$alert_threshold: Float,
					$description: String,
					$maintain_hrs: Float,
					$tag_ids: [Int],
					$inspection_deadline: DateTime

					) {
						${ADD_DEVICE}
					}
					${fragments.Device}
					${fragments.DeviceTask}
					${fragments.DeviceKpis}
				`,
				variables: {
					name: payload.name,
					category_id: payload.category_id,
					inventory_id: payload.inventory_id,
					manage_employees: payload.manage_employees,
					used_at: payload.used_at,
					code: payload.code,
					serial: payload.serial,
					price: payload.price,
					status: payload.status,
					images: payload.images,
					wd: payload.wd,
					mfg: payload.mfg,
					checked_times: payload.checked_times,
					repaired_total_cost: payload.repaired_total_cost,
					warning_threshold: payload.warning_threshold,
					alert_threshold: payload.alert_threshold,
					description: payload.description || "",
					maintain_hrs: payload.maintain_hrs,
					tag_ids: payload.tag_ids || [],
					inspection_deadline: payload.inspection_deadline || ""
				}
			})
			.then(response => response.data.create_device);
	},

	updateDevice(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DevicesManagementUpdate (
					$id: Int!,
					$category_id: Int!,
					$inventory_id: Int,
					$manage_employees: [Int],
					$used_at: DateTime,
					$name: String!,
					$code: String,
					$serial: String,
					$price: Float,
					$status: Int,
					$images: [Int],
					$mfg: String,
					$wd: String,
					$checked_times: Int,
					$repaired_total_cost: Float,
					$warning_threshold: Float,
					$alert_threshold: Float,
					$is_reset_counter: Boolean,
					$description: String,
					$maintain_hrs: Float,
					$tag_ids: [Int],
					$inspection_deadline: DateTime

					) {
						${UPDATE_DEVICE}
					}
					${fragments.DeviceTask}
					${fragments.Device}
					${fragments.DeviceKpis}
				`,
				variables: {
					id: payload.id,
					name: payload.name,
					category_id: payload.category_id,
					inventory_id: payload.inventory_id,
					manage_employees: payload.manage_employees,
					used_at: payload.used_at,
					code: payload.code,
					serial: payload.serial,
					price: payload.price,
					status: payload.status,
					images: payload.images,
					wd: payload.wd,
					mfg: payload.mfg,
					checked_times: payload.checked_times,
					repaired_total_cost: payload.repaired_total_cost,
					warning_threshold: payload.warning_threshold,
					alert_threshold: payload.alert_threshold,
					is_reset_counter: payload.is_reset_counter || null,
					description: payload.description || "",
					maintain_hrs: payload.maintain_hrs,
					tag_ids: payload.tag_ids || [],
					inspection_deadline: payload.inspection_deadline || ""
				}
			})
			.then(response => response.data.update_device);
	},

	deleteDevice(deviceId) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DevicesManagementDelete ($id: Int!) {
				${DELETE_DEVICE}
			}
			${fragments.DeviceTask}
			${fragments.Device}
			${fragments.DeviceKpis}
		`,
				variables: {
					id: deviceId
				}
			})
			.then(response => response.data.delete_device);
	},

	cloneKpisToDevice(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation CloneKpisToDevice ($id: Int!) {
				${CLONE_KPIS_TO_DEVICE}
			}
			${fragments.Device}
			${fragments.DeviceTask}
			${fragments.DeviceKpis}
		`,
				variables: {
					id: payload ? payload.id : null
				}
			})
			.then(response => {
				return { device: response.data.clone_kpis_to_device };
			});
	},
	exportReportDevice(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ExportReportDevice ($device_id: Int!, $type: String, $from_start_date: String, $to_start_date: String) {
					${EXPORT_REPORT_DEVICE}
				}
			`,
				variables: {
					device_id: payload ? payload.device_id : null,
					type: payload ? payload.type || "html" : "html",
					to_start_date: payload.to_start_date || "",
					from_start_date: payload.from_start_date || ""
				}
			})
			.then(response => {
				return { reportDevice: response.data.export_report_device };
			});
	}
};
